import React from 'react';
import './Header.css';

function Header() {
  return (
    <div className='header'>
        <img className='mylogo' src='https://github.com/davidyi0529/Portfolio_D/raw/master/assets/images/logo.png?raw=true' alt='' />
        <h1>Employee-Directory_D</h1>
    </div>
  );
}

export default Header;